import React from 'react';
import { connect } from 'react-redux';
import { VictoryChart, VictoryBar, VictoryAxis, VictoryGroup } from 'victory';
import { getTenantState } from '../../../store/selectors';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';

function UsersByCampusChart(props) {
  return (
    <div className="users-by-campus-chart">
      <VictoryChart
        domainPadding={{ x: 50, y: 20 }}
        width={1300}
        padding={{ top: 20, bottom: 50, left: 30, right: 40 }}
      >
        <VictoryGroup
          colorScale={reportingCopy.usersByCampus?.colorScale || ['#4f81bd']}
        >
          {Object.entries(props.data).map(([campusName, count]) => (
            <VictoryBar
              barWidth={40}
              data={[{ x: campusName, y: count }]}
              labels={({ datum }) => `${datum.y}`}
              style={{
                labels: { fontFamily: 'Roboto' },
              }}
              key={campusName}
            />
          ))}
        </VictoryGroup>
        <VictoryAxis
          tickFormat={
            (t) => (t.length > 12 ? t.replace(/\s+/g, '\n') : t) // wrap names
          }
          style={{
            tickLabels: {
              fill: '#4A4A4A', // font color
              fontSize: 12, // font size
              padding: 10, // equivalent to "10px 0px 0px"
              textAnchor: 'middle',
              lineHeight: 1.2,
              // fontWeight: 400,
            },
          }}
        />
      </VictoryChart>
    </div>
  );
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps)(UsersByCampusChart);
